import React from "react";

const ArrowUp = props => (
  <svg viewBox="0 0 26 16" {...props}>
    <path
      d="M24.561 14.96L14.431 1.58a1.517 1.517 0 00-1.184-.643 1.511 1.511 0 00-1.223.562L1.472 15.068"
      stroke="currentColor"
      strokeWidth={1.92}
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ArrowUp;
